<template>
  <b-modal
    v-model="modal"
    modal-class="mc-modal-history"
    size="md"
    scrollable
    hide-footer
    :title="title"
  >
    <div class="card-body p-2 histories-container">
      <div
        v-for="(groupedHistory, indexParent) in data"
        :key="indexParent"
        class="d-flex gap-2 justify-content-between align-items-stretch __grouped"
      >
        <div class="__left">
          <i class="icon-outline_arrow-circle-right __icon"></i>
          <div class="__dashed-line"></div>
        </div>
        <div class="__info-per-day">
          <p>{{ keys[indexParent] }}</p>
          <div
            v-for="(item, indexChild) in groupedHistory[keys[indexParent]]"
            :key="indexChild"
            class="d-flex gap-4 justify-content-between __info"
          >
            <div>
              {{ formatDateWithTz(item.created_on, 'HH:mm') }}
            </div>
            <slot name="content" :item="item">
              <div :class="item.clickable ? 'mb-2' : ''">
                <p>
                  {{ item.title }}
                  <span v-if="item.hasBadge">
                    <McBadge
                      :text="item.badgeText"
                      :variant="item.badgeVariant"
                      :icon="item.badgeIcon"
                    />
                  </span>
                </p>

                <p>{{ item.description }}</p>
                <template v-if="Object.hasOwn(item, 'properties')">
                  <p v-for="(val, key) in item.properties" :key="key">
                    {{ val.key }}:
                    <span v-if="val.isRedirectable" class="__val text-secondary">
                      <a
                        v-if="val.redirectUrl"
                        v-b-tooltip.hover.bottom
                        title="Lihat Detail Penugasan"
                        @click="$router.push(val.redirectUrl)"
                      >
                        <strong class="text-secondary">
                          {{ val.value }}
                        </strong>
                      </a>
                      <strong v-else class="text-secondary">
                        {{ val.value }}
                      </strong>
                    </span>
                    <span v-else class="__val">{{ getVal(val.value) }}</span>
                  </p>
                </template>
                <a v-if="item.clickable" class="mt-2" @click="handleClick(item, indexChild)">
                  <strong class="text-secondary">
                    {{ item.clickableTitle }}
                  </strong>
                </a>
              </div>
            </slot>
          </div>
        </div>
      </div>
      <i class="icon-fill_radio-button-on __icon"></i>
    </div>
  </b-modal>
</template>
<script>
import McBadge from '@/components/McBadge'
import { formatDateWithTz } from '@/helpers/tzDate'
import moment from 'moment'
moment.locale('id')

export default {
  components: {
    McBadge,
  },
  props: {
    value: {
      type: Boolean,
      require: true,
    },
    title: {
      type: String,
    },
    data: {
      type: Array,
      default: () => [],
    },
    keys: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    modal: {
      set(val) {
        this.$emit('update:value', val)
      },
      get() {
        return this.value
      },
    },
    slotContent() {
      return this.$slots
    },
  },
  methods: {
    formatDateWithTz,
    getVal(str) {
      if (moment(str, moment.ISO_8601, true).isValid() && !/^-?\d+$/.test(str)) {
        return formatDateWithTz(str, 'DD MMM YYYY HH:mm')
      }
      return str
    },
    handleClick(item) {
      this.$emit('itemClick', item)
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(#other-options) {
  .dropdown-menu {
    right: 0px;
    left: auto !important;
  }

  .dropdown-toggle {
    border: none;
  }
}

:deep(.mc-modal-history) {
  .modal-dialog {
    overflow: hidden;
    height: 100%;
    margin: 0;
    margin-left: auto;
  }

  .modal-content {
    height: 100%;
  }

  .modal-content,
  .modal-header {
    border-radius: 0;
  }

  .histories-container {
    .__grouped {
      width: 425px;

      .__left,
      .__info-per-day {
        align-self: stretch;
      }

      .__left {
        width: 20px;
        position: relative;
        .__icon:before {
          color: #344264;
        }

        .__dashed-line {
          position: absolute;
          top: 20px;
          left: 10px;
          bottom: 0;
          border-left: 1px dashed #99a1b1;
          width: 1px;
        }
      }
      .__info-per-day {
        color: $mep-color-text-400;
        line-height: 20px;

        p:first-child,
        .__val {
          color: $mep-color-text-300;
          font-weight: 600;
          font-size: 13px;
        }

        p:not(:last-child) {
          margin: 0;
        }

        .__info {
          div:nth-child(2) {
            width: 300px;
          }
        }
      }
    }

    .__icon:before {
      color: #99a1b1;
      font-size: 20px;
    }
  }
}
</style>
